import { useGetAllStatuses } from 'shared/hooks/use-get-all-statuses';
import { useWarehouseGroups } from 'shared/hooks/use-warehouse-groups';
import type { ICargoFilter } from 'shared/stores/use-cargo-filters';
import { buildComplexCargoFilters } from 'shared/utils/filters/build-complex-cargo-filters';

interface IParams {
  filters?: ICargoFilter;
  includeFromStatuses?: boolean;
}

export const useCargoStatusFilters = (params?: IParams) => {
  const { filters, includeFromStatuses = false } = params || {};
  const { statusesMap } = useGetAllStatuses({ includeFromStatuses });
  const { groups: warehouseGroups } = useWarehouseGroups();

  const { cargoStatuses, complexStatusTypes, complexWarehouseFilters, ...filtersWithoutStatuses } = filters || {};

  const statusFilters: string[] = [];

  if (complexStatusTypes?.length) {
    const selectedWarehouseGroups = complexWarehouseFilters?.flatMap(
      (value) => warehouseGroups.find((group) => group.value === value) ?? [],
    );

    const complexFilters = buildComplexCargoFilters(complexStatusTypes, selectedWarehouseGroups);
    complexFilters.forEach((filter) => {
      statusFilters.push(JSON.stringify(filter));
    });
  } else if (cargoStatuses) {
    cargoStatuses.forEach((status) => {
      const currentValue = statusesMap.get(status);
      if (currentValue) statusFilters.push(JSON.stringify(currentValue));
    });
  }

  return { statusFilters, filtersWithoutStatuses };
};

export const setStatusFiltersToQs = (qs: URLSearchParams, statusFilters: string[]) => {
  statusFilters.forEach((filter, index) => {
    qs.set(`filter[cargoStatuses][${index}]`, filter);
  });
};
